// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const AssetFragmentDoc = `
    fragment asset on Asset {
  __typename
  id
  url
}
    `;